import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "search-suggestions",
  class SearchSuggestions extends WYATTElement {
    constructor() {
      super();

      this.searchTerms = this.getAttribute("data-search-terms");
      this.maxSuggestions = parseInt(this.getAttribute("data-max") || "3", 10);
      this.list = this.querySelector("[data-suggestions-list]");
      this.labelTemplate = this.querySelector("[data-label-template]");
      this.template = this.querySelector("[data-suggestion-template]");

      if (this.searchTerms && this.list && this.template) {
        this.fetchSuggestions();
      }
    }

    async fetchSuggestions() {
      const url = `${WYATT.routes.predictive_search_url}?q=${encodeURIComponent(
        this.searchTerms,
      )}&resources[type]=query&resources[limit]=${this.maxSuggestions}`;

      try {
        const response = await fetch(url, {
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(response.status);
        }

        const data = await response.json();
        const queries = data.resources?.results?.queries || [];

        this.renderSuggestions(queries);
      } catch {
        this.remove();
      }
    }

    renderSuggestions(queries) {
      if (!queries.length) {
        this.remove();
        return;
      }

      const fragment = document.createDocumentFragment();

      queries.slice(0, this.maxSuggestions).forEach((query) => {
        const clone = this.template.content.cloneNode(true);
        const link = clone.querySelector("a");

        link.href = `${WYATT.routes.search_url}?q=${encodeURIComponent(query.text)}&type=product`;
        link.textContent = query.text;

        fragment.appendChild(clone);
      });

      if (this.labelTemplate) {
        this.list.before(this.labelTemplate.content.cloneNode(true));
      }
      this.list.appendChild(fragment);
      this.removeAttribute("hidden");
    }
  },
);
